import React, {Component} from 'react'
import '../../../../../styles/Wyszukiwarka.css'
import {Button} from "react-bootstrap";
import * as acc from "accounting";
import BiletyMiesieczneService from "../BiletyMiesieczneService";

export default class HistoriaKarty extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            downloadLoader: false,
            wyswietlSzczegoly: {}
        }
    }

    componentDidMount() {
        let dataArray = [];
        for (let i = 0; i < this.props.data.length; i++) {
            if (i === this.props.data.length - 1) {
                dataArray.push(this.props.data[i])
            } else {
                if (this.props.data[i].miesiac === this.props.data[i + 1].miesiac && this.props.data[i].rok === this.props.data[i + 1].rok) {
                    dataArray.push([this.props.data[i], this.props.data[i + 1]]);
                    i = i + 1;
                } else {
                    dataArray.push(this.props.data[i])
                }
            }
        }
        this.setState({data: dataArray})
    }

    checkStatus(status) {
        if (status === null) {
            return 'BRAK'
        }
        if (status === '-1') {
            return 'DO OPŁACENIA'
        }
        if (status === '1') {
            return 'OPŁACONY'
        }
    }

    pokazSzczegoly(id) {
        this.setState({
            wyswietlSzczegoly: {
                ...this.state.wyswietlSzczegoly,
                [id]: !this.state.wyswietlSzczegoly[id]
            }
        });
    }

    pobierzFakture(idBm) {
        this.setState({downloadLoader: true})
        BiletyMiesieczneService.getFaktura(idBm)
            .then((response) => {
                const file = new Blob(
                    [response.data],
                    {type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
                let link = document.createElement('a');
                link.href = fileURL;
                link.setAttribute('download', 'faktura-' + idBm + '.pdf');
                link.click();
                this.setState({downloadLoader: false})
            })

    }

    renderujSzczegoly(item) {
        return <div style={{marginTop: 5}}>
            <div className="row displayNoneMobilka">
                <div className="col-sm-4">Od:</div>
                <div className="col-sm-4">Do:</div>
                <div className="col-sm-4">Cena:</div>
            </div>
            {item.length === undefined ?
                <div className="row mobilkaCenter">
                    <div className="col-sm-12">
                        <hr style={{marginTop: 3, marginBottom: 3}}/>
                    </div>
                    <div className="col-sm-4">
                        <b>{item.nazMiOd}</b>
                    </div>
                    <div className="col-sm-4">
                        <b>{item.nazMiDo}</b>
                    </div>
                    <div className="col-sm-4">
                        <span className="cenaBiletuMies">{acc.formatMoney(item.cena, {
                            symbol: "zł",
                            format: "%v %s"
                        })}</span>
                    </div>
                </div> : <div>
                    {item.map((item, i) => {
                        return <div className="row mobilkaCenter">
                            <div className="col-sm-12">
                                <hr style={{marginTop: 3, marginBottom: 3}}/>
                            </div>
                            <div className="col-sm-4">
                                <b>{item.nazMiOd}</b>
                            </div>
                            <div className="col-sm-4">
                                <b>{item.nazMiDo}</b>
                            </div>
                            <div className="col-sm-4">
                                <span className="cenaBiletuMies">{acc.formatMoney(item.cena, {
                                    symbol: "zł",
                                    format: "%v %s"
                                })}</span>
                            </div>
                        </div>
                    })
                    } </div>
            }</div>
    }

    render() {
        return <div>
            {this.state.data !== undefined && this.state.data !== null && this.state.data.length !== 0 ?
                <div>
                    <div className="row"
                         style={{fontSize: '0.875rem', paddingLeft: 10, paddingRight: 10, paddingTop: 10}}>
                        <div className="col-12 displayNoneMobilka">
                            <div className="row">
                                <div className="col-sm-4">Ważny:</div>
                                <div className="col-sm-3">Status:</div>
                                <div className="col-sm-2">Cena:</div>
                            </div>
                        </div>
                    </div>
                    {this.state.data.map((item, index) => {
                        if (item.length === 2) {
                            return (
                                <div className="wynik biletyMiesieczne" style={{lineHeight: 2.5}}>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="row mobilkaCenter" style={{fontSize: '1rem'}}>
                                                <div className="col-sm-4">
                                                    <b>{item[0].waznyOd} - {item[0].waznyDo}</b>
                                                </div>
                                                <div className="col-sm-3">
                                                    <b>{this.checkStatus(item[0].status)}</b>
                                                </div>
                                                <div className="col-sm-2">
                                                    <span
                                                        className="cenaBiletuMies">{acc.formatMoney((parseFloat(item[0].cena) + parseFloat(item[1].cena)), {
                                                        symbol: "zł",
                                                        format: "%v %s"
                                                    })}</span>
                                                </div>
                                                <div className="col-sm-2">
                                                    <Button onClick={() => {
                                                        this.pokazSzczegoly(index)
                                                    }} bsStyle={'success'}
                                                            style={{
                                                                color: 'white'
                                                            }}> Szczegóły
                                                    </Button>
                                                </div>
                                                <div className="col-sm-1">
                                                    {item[0].status === '1' ? <span> {this.state.downloadLoader ?
                                                        <div className="loaderDim" style={{textAlign: 'center'}}><i
                                                            className="fa fa-spinner fa-pulse fa-fw"
                                                            style={{
                                                                color: '#58b13d'
                                                            }}> </i></div> :
                                                        <i onClick={() => this.pobierzFakture(item[0].idBmGl)}
                                                           className="fa fa-file-text"
                                                           style={{
                                                               color: '#28a745',
                                                               cursor: 'pointer'
                                                           }}/> } </span> : null}
                                                </div>
                                            </div>
                                            {this.state.wyswietlSzczegoly[index] &&
                                            this.renderujSzczegoly(item)
                                            }
                                        </div>
                                    </div>
                                </div>
                            );
                        } else {
                            return (
                                <div className="wynik biletyMiesieczne">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="row" style={{fontSize: '1rem'}}>
                                                <div className="col-sm-4">
                                                    <b>{item.waznyOd} - {item.waznyDo}</b>
                                                </div>
                                                <div className="col-sm-3">
                                                    <b>{this.checkStatus(item.status)}</b>
                                                </div>
                                                <div className="col-sm-2">
                                                    <span className="cenaBiletuMies">{acc.formatMoney(item.cena, {
                                                        symbol: "zł",
                                                        format: "%v %s"
                                                    })}</span>
                                                </div>
                                                <div className="col-sm-2">
                                                    <Button onClick={() => {
                                                        this.pokazSzczegoly(index)
                                                    }} bsStyle={'success'}
                                                            style={{
                                                                color: 'white'
                                                            }}> Szczegóły
                                                    </Button>
                                                </div>
                                                <div className="col-sm-1">
                                                    {item.status === '1' ? <span> {this.state.downloadLoader ?
                                                        <div className="loaderDim" style={{textAlign: 'center'}}><i
                                                            className="fa fa-spinner fa-pulse fa-fw"
                                                            style={{
                                                                color: '#58b13d'
                                                            }}> </i></div> :
                                                        <i onClick={() => this.pobierzFakture(item.idBm)}
                                                           className="fa fa-file-text"
                                                           style={{
                                                               color: '#28a745',
                                                               cursor: 'pointer'
                                                           }}/> } </span> : null}
                                                </div>
                                            </div>
                                            {this.state.wyswietlSzczegoly[index] &&
                                            this.renderujSzczegoly(item)
                                            }
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                    })}
                </div> :
                <div className={"text-center"} style={{marginTop: 25}}>
                    <h4>Brak biletów</h4>
                </div>
            }
        </div>

    }

}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/mojeBiletyComponents/szczegolyKartyComponents/HistoriaKarty.js